import { Task } from './task'
import { Batch } from './batch'

export interface WaggleActivityTaskInterface {
  task?: Task
  /**
   * 摇号批次
   */
  batchs?: Batch[]
  /**
   * 摇号导入人数
   */
  batchReflectionCount?: number
}

export class WaggleActivityTask implements WaggleActivityTaskInterface {
  task?: Task
  /**
   * 摇号批次
   */
  batchs?: Batch[]
  /**
   * 摇号导入人数
   */
  batchReflectionCount?: number

  constructor(props: WaggleActivityTaskInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      task: _task,
      batchs: _batchs,
      batchReflectionCount: _batchReflectionCount,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.task = _task ? new Task(_task) : _task
    this.batchs = _batchs ? _batchs.map((i) => new Batch(i)) : _batchs
    this.batchReflectionCount = _batchReflectionCount
  }
}
